import { Overlay } from "@components/Overlay";
import { OverlayProps } from "@components/Overlay/types";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body, Title4 } from "@components/Typography";
import { useCancelContribution, useErrorBanner, useModal, useSuccessBanner } from "@hooks";
import { i18n, Translations } from "@i18n";
import { EditRecurringContributionModalProps } from "@routes/TransfersRoute/TransactionList/EditRecurringContributionModal/types";

export const SkipContributionModal = ({ item }: EditRecurringContributionModalProps) => {
  const { dismiss } = useModal();

  const { showErrorBanner } = useErrorBanner();
  const { showSuccessBanner } = useSuccessBanner();

  const [cancelContribution, { loading }] = useCancelContribution();

  const handleSubmit = async () => {
    if (!item.id) return showErrorBanner();

    try {
      await cancelContribution({
        variables: {
          transactionId: item.id,
        },
      });

      dismiss();
      showSuccessBanner(i18n.t(Translations.SkipContributionSuccessMessage));
    } catch (e: any) {
      const message = e.graphQLErrors?.[0]?.message;
      showErrorBanner(message);
    }

    dismiss();
  };

  const props: OverlayProps = {
    cta: {
      primary: {
        title: i18n.t(Translations.SkipContributionModalPrimaryCTA),
        onClick: handleSubmit,
        loading,
      },
      secondary: {
        title: i18n.t(Translations.SkipContributionModalSecondaryCTA),
        onClick: dismiss,
      },
    },
  };

  return (
    <Overlay {...props}>
      <Title4>{i18n.t(Translations.SkipContributionModalTitle)}</Title4>
      <Spacing size={SpacingSizes.M} />
      <Body>{i18n.t(Translations.SkipContributionModalSubtitle)}</Body>
      <Spacing size={SpacingSizes.XL} />
    </Overlay>
  );
};
